// Common hooks
import UpdateAlert from "./common/UpdateAlert";

// Component hooks
import Confirm from "./components/Confirm";
import Search from "./components/Search";
import Filter from "./components/Filter";
import Accordion from "./components/Accordion";
import Dropdown from "./components/Dropdown";
import Dismiss from "./components/Dismiss";
import Tooltip from "./components/Tooltip";
import FlashMessages from "./components/FlashMessages";

// Form hooks
import Select from "./forms/Select";
import HandleFormLoading from "./forms/HandleFormLoading";
import DatePicker from "./forms/DatePicker";
import EditorJS from "./forms/EditorJS";
import ApplyButtonState from "./forms/ApplyButtonState";
import ExpenseForm from "./forms/ExpenseForm";
import InvoiceForm from "./forms/InvoiceForm";
import MonthInput from "./forms/MonthInput";
import SimpleFormSubmit from "./forms/SimpleFormSubmit";
import CurrencyInput from "./forms/CurrencyInput";

// Utility hooks
import ScrollLock from "./utils/ScrollLock";
import ScrollBottom from "./utils/ScrollBottom";
import ScrollTop from "./utils/ScrollTop";
import HandleCopyToClipBoard from "./utils/HandleCopyToClipBoard";
import HandlePageLoading from "./utils/HandlePageLoading";
import DisableListNotification from "./utils/DisableListNotification";
import HandleDragNDrop from "./utils/HandleDragNDrop";
import HandleFilterDropdown from "./utils/HandleFilterDropdown";
import PushEvent from "./utils/PushEvent";
import RemoveNotification from "./utils/RemoveNotification";
import Turnstile from "./utils/Turnstile";
import UpdateNotificationBadge from "./utils/UpdateNotificationBadge";
import PayslipsSelectionManager from "./utils/PayslipsSelectionManager";
import ElementCounter from "./utils/ElementCounter";
import PreventNavigation from "./utils/PreventNavigation";

// Payroll hooks
import BulkEarningTable from "./payroll/BulkEarningTable";
import BulkDeductionTable from "./payroll/BulkDeductionTable";

const Hooks = {
  // Common hooks
  UpdateAlert,

  // UI hooks
  Confirm,
  Search,
  Filter,
  Accordion,
  Dropdown,
  Dismiss,
  Tooltip,
  FlashMessages,

  // Form hooks
  Select,
  HandleFormLoading,
  DatePicker,
  EditorJS,
  ApplyButtonState,
  ExpenseForm,
  InvoiceForm,
  MonthInput,
  SimpleFormSubmit,
  CurrencyInput,

  // Utility hooks
  ScrollLock,
  ScrollBottom,
  ScrollTop,
  HandleCopyToClipBoard,
  HandlePageLoading,
  DisableListNotification,
  HandleDragNDrop,
  HandleFilterDropdown,
  PushEvent,
  RemoveNotification,
  Turnstile,
  UpdateNotificationBadge,
  PayslipsSelectionManager,
  ElementCounter,
  PreventNavigation,

  // Payroll hooks
  BulkEarningTable,
  BulkDeductionTable,
};

export default Hooks;
